import React, { useId } from 'react';
import PropTypes from 'prop-types';

const formatToday = (date) => date.toLocaleDateString('en-US', { weekday: 'short', day: 'numeric', month: 'short' });

/**
 * I1 "Needs attention": what deserves a look today, counted over the WHOLE
 * lot (decision D3). Each item is a toggle that applies its filter; it reads
 * pressed only while exactly that filter is set. Items with nothing to show
 * are left out.
 */
function NeedsAttention({ items, today }) {
    const headingId = `${useId().replace(/:/g, '')}-attn`;
    const shown = items.filter((item) => item.count > 0);
    return (
        <section className="inv2-today" role="group" aria-labelledby={headingId}>
            <h2 id={headingId}>Needs attention</h2>
            <span className="inv2-date">{formatToday(today)}</span>
            {shown.map((item) => (
                <button
                    key={item.id}
                    type="button"
                    className="inv2-attn"
                    data-attn={item.id}
                    aria-pressed={item.pressed}
                    onClick={item.onClick}
                >
                    <i className={`inv2-dot v2-tone-${item.tone}`} aria-hidden="true" />
                    <b>{item.count.toLocaleString('en-US')}</b>
                    {' '}
                    {item.text}
                </button>
            ))}
            {shown.length === 0 && <span className="inv2-attn-none">Nothing flagged right now</span>}
        </section>
    );
}

NeedsAttention.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        count: PropTypes.number.isRequired,
        text: PropTypes.string.isRequired,
        tone: PropTypes.string.isRequired,
        pressed: PropTypes.bool.isRequired,
        onClick: PropTypes.func.isRequired,
    })).isRequired,
    today: PropTypes.instanceOf(Date).isRequired,
};

export default NeedsAttention;
